import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="CTO as a Service">
                            <h2>Choose a Model</h2>
                        </div>

                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <h3>What we Offer</h3>
                        <p>We aim to personalize the way we work for our clients and partners. Curating our services and
                            eventually humanizing the experience, our CTO as a Service aims to figure out the kind of
                            CTO model
                            you would ideally need.</p>
                        <Row>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <h5>Part-time CTO:</h5>
                                <ul>
                                    <li>Flexibility</li>
                                    <li>Better insights</li>
                                    <li>Effective communication</li>
                                </ul>
                            </Col>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <h5>Full-time CTO:</h5>
                                <ul>
                                    <li>Industry expertise</li>
                                    <li>Long-term strategic planning</li>
                                    <li>Dedicated partnership</li>
                                </ul>
                            </Col>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <h5>Project-basis CTO:</h5>
                                <ul>
                                    <li>Personalized expertise</li>
                                    <li>Objective insights</li>
                                    <li>Quick evaluation</li>
                                </ul>
                            </Col>
                        </Row>

                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;